import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import Select from "react-select"
import { LoadExternalFormsComponentProps } from "../../../common/types/integration"
import { SelectOption } from "../../../common/types/select/types"
import { isError } from "../../../state/helpers/Error"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import ExternalFormService from "../../../state/integration/ExternalFormService"
import { ExternalForm } from "../../../state/integration/wix/types"

const LoadExternalFormsComponent = (props: LoadExternalFormsComponentProps) => {
    const [formOptions, setFormOptions] = useState<SelectOption<string>[]>([])
    const [externalForms, setExternalForms] = useState<ExternalForm[]>([])

    useEffect(() => {
        loadFormOptions()
    }, [])

    useEffect(() => {
        if(props.selectedForm && externalForms.length > 0) {
            handleChange(props.selectedForm)
        }
    }, [externalForms])

    const loadFormOptions =  async() => {
        const response = await ExternalFormService.getAllForms(INTEGRATION_KEY.WIX)
        if (!isError(response) && response) {
            const opt: Array<SelectOption<string>> = response.map(p => {
                return { value: p.displayName, label: p.displayName}
            })
            setFormOptions(opt)
            setExternalForms(response)
        }
        return []
    }
    
    const handleChange = (selectedForm: SelectOption<string>) => {
        const externalForm = externalForms.find(form => form.displayName === selectedForm.value)
        props.onFormSelectedCallback(externalForm)
    }

    return (
        <Select
            options={formOptions}
            onChange={handleChange}
            value={props.selectedForm}
            clearable={false}
        />
    )
}
export default injectIntl(LoadExternalFormsComponent)


// WEBPACK FOOTER //
// ./src/integration/form/wix/LoadExternalFormsComponent.tsx